import React from 'react';
import { toast } from 'sonner';

const notification = {
  success: (message: string, icon?: React.ReactNode) => toast.success(message, { icon }),
  error: (message: string, icon?: React.ReactNode) => toast.error(message, { icon }),
  info: (message: string, icon?: React.ReactNode) => toast.info(message, { icon }),
  warning: (message: string, icon?: React.ReactNode) => toast.warning(message, { icon }),
};

export default notification;
